import { render, staticRenderFns } from "./TableIncomeProduct.vue?vue&type=template&id=7946e689"
import script from "./TableIncomeProduct.vue?vue&type=script&lang=js"
export * from "./TableIncomeProduct.vue?vue&type=script&lang=js"
import style0 from "./TableIncomeProduct.vue?vue&type=style&index=0&id=7946e689&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports